/**
 * 공유 드래그-리사이즈 프리미티브 — 마우스 드래그로 한 축(x/y) 값을 clamp 범위 내에서 갱신.
 * 기능(image/video 등)이 "어떤 핸들·어떤 prop"인지만 정하고 저수준 드래그 루프는 여기서 처리.
 *
 *   startDragResize(e, { axis:"x"|"y", startVal, min, max, sign:±1, onMove(v), onEnd() })
 */
export function startDragResize(e, opts) {
  const axis = opts.axis === "y" ? "y" : "x";
  const sign = opts.sign === -1 ? -1 : 1;
  const startCoord = axis === "x" ? e.clientX : e.clientY;
  const clamp = (v) => Math.max(opts.min, Math.min(v, opts.max));
  function move(ev) {
    const cur = axis === "x" ? ev.clientX : ev.clientY;
    opts.onMove(clamp(opts.startVal + sign * (cur - startCoord)));
  }
  function up() {
    document.removeEventListener("mousemove", move);
    document.removeEventListener("mouseup", up);
    if (opts.onEnd) opts.onEnd();
  }
  document.addEventListener("mousemove", move);
  document.addEventListener("mouseup", up);
}
